import { useEffect, useState } from "react";
import FormYearMonth from '../components/form-year-month';
import Header from "../components/header";
import InteractionModel, { InteractionAuthor } from "../data/InteractionModel";
import { GraduationModel, SignupModelHelper } from "../data/SignupModel";
import { months } from '../data/months';
import AmarelinhoService from '../services/AmarelinhoService';
import { AmplitudeService } from '../services/AmplitudeService';

export default function EscolaridadeFim(props: any) {

  const [interactions, setInteractions] = useState<InteractionModel[]>([]);
  const [graduation, setGraduation] = useState<GraduationModel | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    SignupModelHelper.checkLogin().then(async (userId) => {
      if (!userId) {
        document.location = '#/';
      }
    });

    // TagManager.dataLayer(dataLayerHelper.pagina('fim-ano', 'escolaridade'));
    AmplitudeService.track('Education End Date Screen')

    setGraduation(SignupModelHelper.getOngoingGraduation());
    const signup = SignupModelHelper.get();
    if (signup) {
    } else {
      document.location = './';
    }
  }, [])

  function setLeaveYearMonth(yearMonth: string) {
    let chat: any = [];
    const maxYear = new Date().getFullYear();

    const dateFinish: Date = new Date(yearMonth+"-01T12:00");
    const today = new Date();
    today.setHours(12);

    const [year] = yearMonth.split('-');

    chat = [...interactions, {
      text: `${months[dateFinish.getMonth()]} de ${dateFinish.getFullYear()}`,
      author: InteractionAuthor.CLIENTE
    }];
    setInteractions(chat);

    if (isNaN(+year) || +year < 1900) {

      setTimeout(() => {
        setInteractions([...chat, {
          author: InteractionAuthor.AMARELINHO,
          text: `Informe um ano entre 1900 e ${maxYear}`
        }]);
        setTimeout(() => {
          let chat = document.getElementsByClassName('chat')[0];
          chat.scrollTo(0, chat.scrollHeight);
        }, 500);
      }, 1000)
    } else if (new Date(graduation?.start!).getFullYear() > +year) {

      setTimeout(() => {
        setInteractions([...chat, {
          author: InteractionAuthor.AMARELINHO,
          text: `O ano de saída deve ser o mesmo ou posterior ao de entrada.`
        }]);
        setTimeout(() => {
          let chat = document.getElementsByClassName('chat')[0];
          chat.scrollTo(0, chat.scrollHeight);
        }, 500);
      }, 1000)

    } else if (dateFinish > today) {
      const nextMonth = new Date();
      nextMonth.setMonth(nextMonth.getMonth() + 1);
      setTimeout(() => {
        setInteractions([...chat, {
          author: InteractionAuthor.AMARELINHO,
          text: `Selecione um mês anterior a ${months[nextMonth.getMonth()]} de ${nextMonth.getFullYear()}.`
        }]);

        setTimeout(() => {
          let chat = document.getElementsByClassName('chat')[0];
          chat.scrollTo(0, chat.scrollHeight);
        }, 500);
      }, 1000)
    } else if (dateFinish < new Date(graduation?.start!)) {

      setTimeout(() => {
        setInteractions([...chat, {
          author: InteractionAuthor.AMARELINHO,
          text: `O mês de saída deve ser o mesmo ou posterior ao de entrada.`
        }]);
        setTimeout(() => {
          let chat = document.getElementsByClassName('chat')[0];
          chat.scrollTo(0, chat.scrollHeight);
        }, 500);
      }, 1000)

    } else {
      const signup = SignupModelHelper.updateGraduation({
        finish: dateFinish,
        saved: true
      });

      if (signup) {
        setLoading(true);
        AmarelinhoService.saveGraduation(signup).then((ret) => {
          if (!ret.success) {
            setTimeout(() => {
              setInteractions([...chat, {
                author: InteractionAuthor.AMARELINHO,
                text: ret.message
              }]);
              setTimeout(() => {
                let chat = document.getElementsByClassName('chat')[0];
                chat.scrollTo(0, chat.scrollHeight);
              }, 500);
            }, 1000)
          } else {
            // TagManager.dataLayer(dataLayerHelper.formEnviado('form_escolaridade'));
            AmplitudeService.track('Education End Date Submit')
            SignupModelHelper.update({ graduations: undefined });
            document.location = '#/cursos';
          }
          setLoading(false);
        })
      }
    }
  }

  return (
    <>
      <Header step={ 6 } total={ 6 } title="Escolaridade" previous="#/escolaridade-inicio"></Header>

      <FormYearMonth
        lastAnswer={ `${months[new Date(graduation?.start!).getMonth()]} de ${new Date(graduation?.start!).getFullYear()}` }
        question="Agora, <strong>quando foi a saída</strong>?"
        interactions={ interactions }
        loading={ loading }
        onSubmit={ setLeaveYearMonth }
      />
    </>);
}
